import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { scheduledReportTypeTranslationMap } from 'dashboard/constants/scheduled-report-type-translation-map.constant';
import { BaseDataGridCellRenderer } from 'shared/abstract/base-data-grid-cell-renderer';

@Component({
    selector: 'app-scheduled-reports-report-type-cell-renderer',
    imports: [TranslateModule],
    templateUrl: './scheduled-reports-report-type-cell-renderer.component.html',
    styleUrl: './scheduled-reports-report-type-cell-renderer.component.scss',
})
export class ScheduledReportsReportTypeCellRendererComponent extends BaseDataGridCellRenderer {
    protected readonly reportTypeTranslationMap: any = scheduledReportTypeTranslationMap;

    public onDataChange(): any {}
}
